import { RootState } from '../../../rootReducer';
import { EditCompanyState } from './types';

export const selectEditCompanyState = (state: RootState): EditCompanyState =>
  state.companies.edit;
